<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.subscriptions.retrieveLoader">
      <piriod-view-loader view-type="retrieve" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{name: 'ProductRetrieveUpdate', params: {id: product.id}}" class="subtitle-1 routerLink font-weight-medium">{{product.name}}</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium display-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 500px;'">{{instance.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-1" @click="dialogPlan=true" outlined retain-focus-on-click color="secondary">Editar</v-btn>
              <v-menu close-on-click close-on-content-click left offset-y :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="deletePlan">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium">Eliminar plan</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Descripción</v-list-item-title>
                  <v-list-item-subtitle>{{instance.description}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Frecuencia de facturación</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.frequency">{{instance.frequency.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Producto</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn :to="{name: 'ProductRetrieveUpdate', params: {id: product.id}}" text color="primary">{{product.name}}</v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Suscripciones</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn :to="{name: 'SubscriptionList', query: {lines__plan: instance.id}}" text color="primary">Ver suscripciones</v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- table pricing  -->
      <v-card class="mt-3">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Precio</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
        <v-row>
          <v-col md="8">
            <v-list class="v-list-form transparent">
              <v-list-item>
                <v-list-item-title>Moneda</v-list-item-title>
                <v-list-item-subtitle v-if="instance.frequency">{{activeCurrency.id}} - {{activeCurrency.name}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Exento de impuestos</v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="instance.exempt">Si</span>
                  <span v-else>No</span>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Tipo de uso</v-list-item-title>
                <v-list-item-subtitle v-if="instance.usage_scheme === 'licensed'">Fee periódico</v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="instance.usage_scheme === 'metered'">Cobro por uso</v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="instance.usage_scheme === 'metered'">
                <v-list-item-title>Esquema de cálculo</v-list-item-title>
                <v-list-item-subtitle v-if="instance.usage_aggregation === 'sum'">Suma de los registros de uso informados en el periodo</v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="instance.usage_aggregation === 'max'">Máximo registro de uso informado en el periodo</v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="instance.usage_aggregation === 'last_record'">Último registro de uso informado en el período</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Precio unitario</v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="instance.tiers_mode">Definido por niveles</span>
                  <span v-else>{{instance.amount | currency(activeCurrency.id)}}</span>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <template v-if="instance.tiers_mode">
          <tier-list :tiers="instance.tiers" :currency="instance.currency.id" :tiers-mode="instance.tiers_mode" />
        </template>
        </v-card-text>
      </v-card>
      <!-- end table pricing -->

      <!-- table metadata  -->
      <v-card class="mt-3">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Metadata</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn class="mr-1" @click="dialogMetadata=true" outlined retain-focus-on-click color="secondary">Editar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="6" v-if="Object.keys(instance.metadata).length">
              <v-list class="transparent">
                <v-list-item v-for="(v, k) in instance.metadata" :key="k">
                  <v-list-item-title>{{k}}</v-list-item-title>
                  <v-list-item-subtitle>{{v}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" v-else class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-code-tags</v-icon>
              <span class="d-block subtitle-1">No hay metadatos</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end table pricing -->
    </v-col>

    <!-- dialog plan update -->
    <v-dialog v-model="dialogPlan" width="600" persistent no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar plan</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogPlan=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>
                Nombre
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>No será visible para los clientes, pero te ayudará a identificar este plan en tu cuenta.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense maxlength="56" placeholder="Escribe un nombre" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>
                Descripción
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Está es la descripción que verán tus clientes en sus factura.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.description.$model" :error="$v.editable.description.$error" background-color="white" outlined required single-line dense maxlength="200" />
              </v-list-item-subtitle>
            </v-list-item>

            <!-- more options -->
            <v-list-item class="mt-6">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Otras opciones</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="my-3">
              <v-list-item-title>Código</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-text-field id="it-plan-sku" v-model.trim="$v.editable.sku.$model" :error="$v.editable.sku.$error" background-color="white" outlined required single-line dense maxlength="32" persistent-hint hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="my-3">
              <v-list-item-title>Unidad</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-text-field id="it-plan-unit_label" v-model.trim="$v.editable.unit_label.$model" :error="$v.editable.unit_label.$error" background-color="white" placeholder="Etiqueta de unidad" outlined required single-line dense maxlength="4" persistent-hint hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <!-- end more options -->
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogPlan=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="updatePlan" :loading="$store.state.subscriptions.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog plan update -->

    <!-- dialog metadata -->
    <v-dialog v-if="editable.id" v-model="dialogMetadata" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Editar metadatos</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 background">
          <v-row no-gutters v-if="editableMetadata.length" align="center">
            <v-col cols="4">
              <span class="body-2 text--secondary font-weight-medium ml-1">Clave</span>
            </v-col>
            <v-col cols="8">
              <span class="body-2 text--secondary font-weight-medium ml-1">Valor</span>
            </v-col>
          </v-row>
          <v-row no-gutters v-for="(d, i) in editableMetadata" :key="i" align="center">
            <v-col cols="4" class="py-1">
              <v-text-field v-model.trim="$v.editableMetadata.$each[i].key.$model" :error="$v.editableMetadata.$each[i].key.$error" background-color="white" outlined required single-line dense maxlength="32" hide-details />
            </v-col>
            <v-col cols="7" class="py-1">
              <v-text-field v-model.trim="$v.editableMetadata.$each[i].value.$model" :error="$v.editableMetadata.$each[i].value.$error" background-color="white" outlined required single-line dense maxlength="256" hide-details />
            </v-col>
            <v-col cols="1" class="py-1 text-right">
              <v-btn v-if="i >= 1 || editableMetadata.length > 1" @click="editableMetadata.splice(i, 1)" icon color="secondary"><v-icon small>mdi-delete</v-icon></v-btn>
            </v-col>
            <v-col cols="12" v-if="!$v.editableMetadata.$each[i].key.itsRepeated">
              <span class="d-block red--text caption ml-1 mt-n1 mb-1"><v-icon color="red" small left>mdi-alert-circle</v-icon>La clave debe ser única.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="3">
              <v-btn @click="editableMetadata.push({ key: '', value: '' })" :disabled="editableMetadata.length >= 10" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar elemento</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogMetadata=false" outlined>Cancelar</v-btn>
          <v-btn @click="updateMetadata" :loading="loaderMetadata" :disabled="!editableMetadata.length" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog metadata -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import TierList from '@/components/subscription/TierList'

export default {
  mixins: [
    GenericViewMixin
  ],
  components: {
    TierList
  },
  data: () => ({
    activeCurrency: {},
    dialogPlan: false,
    dialogMetadata: false,
    editable: {},
    editableMetadata: [{ key: '', value: '' }],
    loaderMetadata: false
  }),
  computed: mapState({
    instance: state => state.subscriptions.plansDetail,
    product: state => state.subscriptions.productsDetail
  }),
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'plans',
      id: this.$route.params.id
    })
    .then(() => {
      this.editable = Object.assign({}, this.instance)
    })
    .then(() => {
      this.editableMetadata = Object.keys(this.instance.metadata).map((k) => {
        return { key: k, value: this.instance.metadata[k] }
      })
    })
    .then(() => {
      this.$store.dispatch('subscriptions/RETRIEVE', {
        resource: 'products',
        id: this.instance.product
      })
    })
    .then(() => {
      this.activeCurrency = this.currencies.find(c => c.id === this.instance.currency.id)
    })
  },
  methods: {
    updatePlan () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        sku: this.editable.sku,
        description: this.editable.description,
        name: this.editable.name,
        unit_label: this.editable.unit_label
      }
      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'plans',
        id: this.$route.params.id,
        payload: payload
      })
      .then(() => {
        this.dialogPlan = false
        this.$dialog.message.info('El plan ha sido actualizado')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    deletePlan () {
      this.$dialog.warning({
        title: 'Eliminar plan',
        text: `
          <span class="d-block mb-4">Al eliminar este plan, no podrás asociarlo a nuevas suscripciones. Las suscripciones activas no serán afectadas y se seguirán facturando hasta que se cancelen.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
             this.$store.dispatch('subscriptions/DESTROY', {
                resource: 'plans',
                id: this.instance.id
              })
              .then(() => {
                this.$dialog.message.info('El plan ha sido eliminado')
                this.$router.push({
                  name: 'ProductRetrieveUpdate',
                  params: {
                    id: this.editable.product
                  }
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    updateMetadata () {
      this.$v.editableMetadata.$touch()

      if (this.$v.editableMetadata.$invalid) {
        return false
      }

      this.loaderMetadata = true

      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'plans',
        id: this.instance.id,
        payload: {
          metadata: Object.fromEntries(this.editableMetadata.map(({ key, value }) => [key, value]))
        }
      })
      .then(() => {
        this.dialogMetadata = false
        this.$dialog.message.info('Los metadatos del plan se han guardado.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderMetadata = false
      })
    }
  },
  validations: {
    editable: {
      sku: {
        maxLength: maxLength(32)
      },
      name: {
        required,
        maxLength: maxLength(56)
      },
      description: {
        required,
        maxLength: maxLength(200)
      },
      unit_label: {
        maxLength: maxLength(4)
      }
    },
    editableMetadata: {
      $each: {
        key: {
          required,
          maxLength: maxLength(32),
          itsRepeated: function (value) {
            if (value) {
              return (this.editableMetadata.filter(d => d.key === value).length === 1)
            }
            return true
          }
        },
        value: {
          required,
          maxLength: maxLength(256)
        }
      },
      minLength: minLength(1),
      maxLength: maxLength(10)
    }
  }
}
</script>